import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=470d6a76&scoped=true&"
import script from "./VehicleList.vue?vue&type=script&lang=js&"
export * from "./VehicleList.vue?vue&type=script&lang=js&"
import style0 from "./VehicleList.vue?vue&type=style&index=0&id=470d6a76&lang=scss&scoped=true&"
import style1 from "./VehicleList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d6a76",
  null
  
)

export default component.exports